var React = require('react');

function Mv (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#d21034","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#007e3a","d":"M120 120h400v240H120z","key":1}),React.createElement("circle",{"cx":"350","cy":"240","r":"80","fill":"#fff","key":2}),React.createElement("circle",{"cx":"380","cy":"240","r":"80","fill":"#007e3a","key":3})]);
}

Mv.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Mv;

Mv.default = Mv;
